function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './DefaultCards.css';
import React, { useEffect, useState } from 'react';
import { useSitecoreContext } from '../../../utils/SitecoreContextReactContext';
import { canUseDOM, get, getGlobalDictionaryTerm } from '../../../utils';
import { convertToAnalyticObject } from '../../../utils/analytics';
import ScrollAnimation from 'react-animate-on-scroll';
import { Link, RichText, Text } from '@sitecore-jss/sitecore-jss-react';
import { tealiumClickFunc, tealiumMergeClickNewData } from '../../../utils/tealium';
import RouterLink from '../../atoms/RouterLink';
import CarouselProvider from '../../atoms/CarouselProvider/CarouselProvider';
import { ReactComponent as IconChevronRightLight } from '../../../resources/icons/IconChevronRightLight.svg';
import { ReactComponent as IconChevronLeftLight } from '../../../resources/icons/IconChevronLeftLight.svg';
import { ReactComponent as IconChevronLeftDetLight } from '../../../resources/icons/chevron-left-24-px.svg';
import { ReactComponent as IconChevronRightDetLight } from '../../../resources/icons/chevron-right-24-px.svg';
import LazyPicture from '../../atoms/LazyPicture';
const Cards = _ref => {
  let {
    item,
    itemsLength,
    eventsAnalytics,
    params
  } = _ref;
  const [mediaWidth992px, setMediaWidth992px] = useState(canUseDOM ? window.matchMedia("(max-width: 992px)").matches : false);
  const isDetSite = get(params, 'RenderingStyle') === 'DDA' || false;
  const sitecoreContext = useSitecoreContext();
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const newWindowLabel = getGlobalDictionaryTerm(sitecoreContext, 'newWindowLabel') || "Opens in a new window";
  const cardImageSrc = get(item, 'image.jss.value.src');
  const cardImageAlt = get(item, 'image.jss.value.alt');
  const hasTitle = get(item, 'title.jss.value');
  const hasDescription = Boolean(get(item, 'description.jss.value'));
  const ctaLabel = get(item, 'ctaLabel.jss.value');
  const ctaLinkHref = get(item, 'ctaLink.jss.value.href');
  const ctaLinktype = get(item, 'ctaLink.jss.value.linktype');
  useEffect(() => {
    if (canUseDOM) {
      window.addEventListener("resize", () => {
        setMediaWidth992px(window.matchMedia("(max-width: 992px)").matches);
      });
    }
    return () => {
      if (canUseDOM) {
        window.addEventListener("resize", () => {
          setMediaWidth992px(window.matchMedia("(max-width: 992px)").matches);
        });
      }
    };
  }, []);
  const renderLink = () => {
    if (!ctaLabel || !ctaLinkHref) return null;
    if (pageEditing && ctaLinkHref) {
      return /*#__PURE__*/React.createElement(Link, {
        field: item.ctaLink.jss
      });
    }
    return /*#__PURE__*/React.createElement("div", {
      className: "c--link-more"
    }, /*#__PURE__*/React.createElement(RouterLink, {
      href: ctaLinkHref,
      isDetSite: isDetSite,
      linktype: ctaLinktype,
      colorText: `var(--general-card-complete-round-text-color)`,
      color: `var(--general-card-complete-round-color)`,
      colorActive: `var(--general-card-complete-round-active-color)`,
      onClick: () => tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['discoverMoreAnalytics'], params), [item.title.jss.value, item.ctaLabel.jss.value])
    }, ctaLabel, ctaLabel && ctaLinkHref ? isDetSite ? rtl ? /*#__PURE__*/React.createElement(IconChevronLeftDetLight, null) : /*#__PURE__*/React.createElement(IconChevronRightDetLight, null) : rtl ? /*#__PURE__*/React.createElement(IconChevronLeftLight, null) : /*#__PURE__*/React.createElement(IconChevronRightLight, null) : null));
  };
  const renderContentInLink = children => {
    if (!ctaLinkHref && !pageEditing) return /*#__PURE__*/React.createElement("div", {
      style: {
        textAlign: isDetSite ? 'start' : 'center'
      }
    }, children);
    let linkTitle = '';
    if (hasTitle) {
      linkTitle = hasTitle;
    } else {
      linkTitle = cardImageAlt ? cardImageAlt : '';
    }
    if (ctaLabel) {
      linkTitle = `${ctaLabel} | ${linkTitle}`;
    }
    if (item.ctaLink && item.ctaLink.jss && item.ctaLink.jss.value && item.ctaLink.jss.value.target === "_blank") {
      linkTitle = linkTitle ? `${linkTitle} | ${newWindowLabel}` : newWindowLabel;
    }
    const updatedLinkField = _objectSpread(_objectSpread({}, item.ctaLink.jss), {}, {
      target: get(item, 'ctaLink.jss.value.target') || "_self"
    });
    return /*#__PURE__*/React.createElement(Link, {
      "aria-label": linkTitle,
      field: updatedLinkField,
      style: {
        textAlign: isDetSite ? 'start' : 'center',
        display: isDetSite ? 'inline-flex' : 'initial'
      }
    }, children);
  };
  const defaultCardRender = () => /*#__PURE__*/React.createElement("div", null, (hasTitle || hasDescription || renderLink()) && /*#__PURE__*/React.createElement("div", {
    className: "card--item__icon"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-box cardBoxDefault theme-contrast"
  }, cardImageSrc ? renderContentInLink(/*#__PURE__*/React.createElement(LazyPicture, {
    onClick: () => {
      tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['bannerClickAnalytics'], params), hasTitle);
    },
    useEmptyPlaceholder: true,
    hover: true,
    className: "h__icon iconCircle"
  }, /*#__PURE__*/React.createElement("source", {
    media: "(max-width: 992px)",
    srcSet: cardImageSrc
  }), /*#__PURE__*/React.createElement("img", {
    src: cardImageSrc,
    alt: cardImageAlt
  }))) : null, hasTitle ? /*#__PURE__*/React.createElement(Text, {
    tag: "p",
    className: "h__title body-large cardTitle",
    field: item.title && item.title.jss
  }) : null, hasDescription ? /*#__PURE__*/React.createElement(Text, {
    tag: "p",
    className: "h__title body-large cardDescription",
    field: item.description && item.description.jss
  }) : null, renderLink())));
  const uniqueCardRenderForTwoOrThreeItems = () => /*#__PURE__*/React.createElement("div", null, (hasTitle || hasDescription || renderLink()) && /*#__PURE__*/React.createElement("div", {
    className: "card--item__icon"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-box uniqueCardBox theme-contrast"
  }, /*#__PURE__*/React.createElement("div", {
    className: "uniqueCardBoxDesktop"
  }, cardImageSrc ? renderContentInLink(/*#__PURE__*/React.createElement(LazyPicture, {
    onClick: () => {
      tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['bannerClickAnalytics'], params), hasTitle);
    },
    useEmptyPlaceholder: true,
    hover: true,
    className: `h__icon ${itemsLength === 2 ? "uniqueIconCircleTwoItem" : "uniqueIconCircleThreeItem"}`
  }, /*#__PURE__*/React.createElement("source", {
    media: "(max-width: 992px)",
    srcSet: cardImageSrc
  }), /*#__PURE__*/React.createElement("img", {
    src: cardImageSrc,
    alt: cardImageAlt
  }))) : null, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "column",
      flex: 1,
      justifyContent: `${itemsLength === 1 ? 'start' : 'center'}`
    }
  }, hasTitle ? /*#__PURE__*/React.createElement(Text, {
    tag: "p",
    className: "h__title body-large cardTitle",
    field: item.title && item.title.jss
  }) : null, mediaWidth992px ? null : /*#__PURE__*/React.createElement(React.Fragment, null, "   ", hasDescription ? /*#__PURE__*/React.createElement(Text, {
    tag: "p",
    className: "h__title body-large cardDescription",
    field: item.description && item.description.jss
  }) : null, " ", renderLink()))), mediaWidth992px ? /*#__PURE__*/React.createElement(React.Fragment, null, "   ", hasDescription ? /*#__PURE__*/React.createElement(Text, {
    tag: "p",
    className: "h__title body-large cardDescription",
    field: item.description && item.description.jss
  }) : null, " ", renderLink()) : null)));
  return itemsLength === 2 || itemsLength === 3 || itemsLength === 4 && mediaWidth992px ? uniqueCardRenderForTwoOrThreeItems() : defaultCardRender();
};
const DefaultCards = _ref2 => {
  let {
    fields,
    params
  } = _ref2;
  const sitecoreContext = useSitecoreContext();
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const isDetSite = get(params, 'RenderingStyle') === 'DDA' || false;
  const ctaLeftIcon = get(fields, 'data.item.ctaLeftIcon.targetItem.svg.jss.value');
  const ctaRightIcon = get(fields, 'data.item.ctaRightIcon.targetItem.svg.jss.value');
  const defaultCardsHasTitle = Boolean(get(fields, 'data.item.title.jss.value'));
  const defaultCardsHasDescription = Boolean(get(fields, 'data.item.description.jss.value'));
  const childrenItems = get(fields, 'data.item.children', []);
  const ctaLabel = get(fields, 'data.item.ctaLabel.jss.value');
  const ctaLink = get(fields, 'data.item.ctaLink.jss.value.href');
  const linktype = get(fields, "data.item.ctaLink.jss.value.linktype");
  let eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  const items = childrenItems.length ? childrenItems.filter(item => item.title && item.description) : [];
  const classItemWidthMap = {
    1: "oneItemWidth",
    2: "twoItemWidth",
    3: "threeItemWidth",
    4: "fourItemWidth"
  };
  const renderButtonLink = () => /*#__PURE__*/React.createElement("div", {
    className: "btnLink"
  }, /*#__PURE__*/React.createElement(RouterLink, {
    className: `btn ${isDetSite ? 'btn-primary' : 'btn-secondary'}`,
    isDetSite: isDetSite,
    href: ctaLink,
    title: ctaLabel,
    linktype: linktype,
    ctaLeftIcon: ctaLeftIcon,
    ctaRightIcon: ctaRightIcon,
    rtl: rtl,
    colorText: `var(--general-card-complete-round-text-color)`,
    color: `var(--general-card-complete-round-color)`,
    colorActive: `var(--general-card-complete-round-active-color)`,
    onClick: () => tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['seeMoreAnalytics'], params), [fields.data.item.title.jss.value, ctaLabel])
  }, ctaLabel));
  const renderItems = () => {
    return items.map((item, index) => /*#__PURE__*/React.createElement(ScrollAnimation, {
      className: `itemWidth ${classItemWidthMap[items.length]}`,
      animateIn: "animate__fadeInUp",
      animateOnce: true,
      duration: 1 + index / 3,
      key: index
    }, /*#__PURE__*/React.createElement(Cards, {
      item: item,
      itemsLength: items.length,
      eventsAnalytics: eventsAnalytics,
      params: params
    })));
  };
  const renderItems04 = () => /*#__PURE__*/React.createElement("div", {
    className: "itemsContainer"
  }, renderItems());
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    isDetSite: isDetSite
  }, defaultCardsHasTitle && items.length < 5 ? /*#__PURE__*/React.createElement(Text, {
    tag: "h3",
    className: "h3 h__title componentTitle",
    field: fields.data.item.title.jss
  }) : null, defaultCardsHasDescription && items.length < 5 ? /*#__PURE__*/React.createElement(RichText, {
    tag: "div",
    className: "body-large c__txt componentDescriptionWithoutCarousel",
    field: fields.data.item.description.jss
  }) : null, items.length < 5 ? renderItems04() : null, items.length >= 5 ? /*#__PURE__*/React.createElement(CarouselProvider, null, _ref3 => {
    let {
      renderCarousel,
      renderPreviousButton,
      renderNextButton,
      renderDots
    } = _ref3;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: `${defaultCardsHasTitle ? 'card__head' : 'cardHeadOnlyWithPagination'}`
    }, defaultCardsHasTitle || defaultCardsHasDescription ? /*#__PURE__*/React.createElement("div", {
      className: "h__txt"
    }, defaultCardsHasTitle ? /*#__PURE__*/React.createElement(Text, {
      tag: "h3",
      className: "h3 h__title componentTitle",
      field: fields.data.item.title.jss
    }) : null, defaultCardsHasDescription ? /*#__PURE__*/React.createElement(Text, {
      tag: "p",
      className: "p componentDescription",
      field: fields.data.item.description.jss
    }) : null) : null, /*#__PURE__*/React.createElement("div", {
      className: "pagination__btn"
    }, /*#__PURE__*/React.createElement("div", {
      className: "btn-group--right"
    }, renderPreviousButton(() => tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['operatingOptionsAnalytics'], params), ['previous']), false, false, null, isDetSite), renderNextButton(() => tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['operatingOptionsAnalytics'], params), ['next']), false, false, null, isDetSite)))), /*#__PURE__*/React.createElement("div", {
      className: "card-container__inner"
    }, renderCarousel(renderItems(), {
      responsive: {
        extra: {
          breakpoint: {
            max: 10000,
            min: 1281
          },
          items: 4
        },
        desktop: {
          breakpoint: {
            max: 1280,
            min: 901
          },
          items: 3
        },
        tablet: {
          breakpoint: {
            max: 900,
            min: 480
          },
          items: 2
        },
        mobile: {
          breakpoint: {
            max: 479,
            min: 0
          },
          items: 1
        }
      },
      containerClass: "carouselContainer"
    })), ctaLink && ctaLabel ? /*#__PURE__*/React.createElement("div", {
      className: "paginationAndLinkContainer"
    }, renderButtonLink(), /*#__PURE__*/React.createElement("div", {
      className: "pagination-dot"
    }, renderDots(() => tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['bubblesAnalytics'], params)), [], isDetSite))) : /*#__PURE__*/React.createElement("div", {
      className: "paginationWithoutLinkContainer"
    }, /*#__PURE__*/React.createElement("div", {
      className: "pagination-dot"
    }, renderDots(() => tealiumClickFunc(tealiumMergeClickNewData(eventsAnalytics['bubblesAnalytics'], params)), [], isDetSite))));
  }) : null);
};
const StyledWrapper = _ref4 => {
  let {
    children,
    rtl,
    className,
    style,
    isDetSite
  } = _ref4;
  const commonStyles = isDetSite ? "cpybobh" : "c1mcfior";
  const ltrStyles = isDetSite ? "lm7exln" : "lltspqj";
  const rtlStyles = isDetSite ? "rylcsz8" : "rl2obc7";
  return /*#__PURE__*/React.createElement("div", {
    style: style,
    className: `${commonStyles} ${rtl ? rtlStyles : ltrStyles} ${className}`
  }, children);
};
export { DefaultCards };